/**
 * Layout: Hero - Vacature detail
 * Slug: hero_vacature_detail
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.hero_vacature_detail-layout');

	layouts.forEach((layout) => {
		
	});
});
